<template>
  <v-card>

    <v-progress-circular v-if="loading"
                         indeterminate
                         color="primary">
    </v-progress-circular>

    <v-card-text>
      <planned-service-properties-view v-if="plannedService != null"
                                       :planned-service="plannedService"
                                       :documents="documents">
        <template v-slot:append>
          <entity-properties-row>
            <v-btn v-if="$featurePermissions.plannedServiceCRUD"
                   tile
                   color="primary"
                   @click="openEditDialog">
              {{ $t('actions.modify') }}
              <v-icon right dark>
                mdi-border-color
              </v-icon>
            </v-btn>
          </entity-properties-row>
        </template>
      </planned-service-properties-view>
      <planned-service-dialog ref="plannedServiceDialog" @done="reload"/>
    </v-card-text>
  </v-card>
</template>

<script>
import Vue from 'vue';
import PlannedServiceService from '@/services/PlannedServiceService';
import EntityPropertiesRow from '@/components/entity-crud/EntyPropertiesRow';
import PlannedServiceDialog from '@/views/plannedService/PlannedServiceDialog';
import PlannedServicePropertiesView from '@/views/plannedService/PlannedServicePropertiesView';

export default Vue.extend({
  name: 'PlannedServiceDetails',
  components: {
    PlannedServicePropertiesView,
    PlannedServiceDialog,
    EntityPropertiesRow,
  },
  data() {
    return {
      plannedService: null,
      documents: [],
      loading: false,

    };
  },
  mounted() {
    this.reload();
  },
  methods: {
    reload() {
      this.loading = true;
      PlannedServiceService.get(this.plannedServiceId).then(result => {
        this.plannedService = result.data.plannedService;
        this.documents = result.data.documents;
      }).catch(err => {
        console.log(JSON.stringify(err));
      }).finally(() => {
        this.loading = false;
      });
    },

    openEditDialog() {
      this.$refs.plannedServiceDialog.openEditForPlannedService(this.plannedServiceId);
    },
  },

  computed: {
    plannedServiceId() {
      return parseInt(this.$route.params.id, 10);
    },

  },
});
</script>
